import Link, { matchHash } from './Link';
import { cEl, removeToken } from '../../util';
import { PATH_ADMIN_LOGIN, PATH_ADMIN_MANAGEMENT, PATH_ADMIN_SUBMISSIONS } from '../path';
import { logout } from '../../api/admin';

function AdminNavigation() {
    const navigation = cEl('nav');
    navigation.classList.add('main-nav');
    const border = cEl('div');
    border.classList.add('thin-border');

    const leftNav = cEl('div');
    leftNav.classList.add('left-nav');

    const adminHomeLink = Link({ innerHTML: '병원 서비스 로봇_Admin', href: PATH_ADMIN_SUBMISSIONS });

    leftNav.appendChild(adminHomeLink);

    const rightNav = cEl('div');
    rightNav.classList.add('right-nav');
    if (!matchHash(PATH_ADMIN_LOGIN)) {
        rightNav.classList.add('admin-nav');

        const managementLink = Link({
            innerHTML: '관리',
            href: PATH_ADMIN_MANAGEMENT,
        });

        const logoutLink = Link({
            innerHTML: '로그아웃',
            href: PATH_ADMIN_LOGIN,
            handleClick: () => {
                logout().then(() => {
                    removeToken();
                });
            },
        });

        rightNav.append(managementLink, logoutLink);
    }

    navigation.append(leftNav, rightNav, border);

    return navigation;
}

export default AdminNavigation;
